module.exports = hoistNonReactStatics;